import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/symbols/payment_providers.svg'


const _withScopeId = n => (_pushScopeId("data-v-723fea2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#mollie'
const _hoisted_2 = _imports_0 + '#payconiq'
const _hoisted_3 = _imports_0 + '#worldline'
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex align-items-center gap-3 mb-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      height: "20px",
      width: "40px"
    }, [
      /*#__PURE__*/_createElementVNode("use", { href: _hoisted_1 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Mollie")
  ])
], -1))
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_11 = {
  key: 1,
  class: "bg-warning missing-feature"
}
const _hoisted_12 = { class: "col-lg-4" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex align-items-center gap-3 mb-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      height: "20px",
      width: "40px"
    }, [
      /*#__PURE__*/_createElementVNode("use", { href: _hoisted_2 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Payconiq")
  ])
], -1))
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_18 = {
  key: 1,
  class: "bg-warning missing-feature"
}
const _hoisted_19 = { class: "col-lg-4" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header py-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title d-flex align-items-center gap-3 mb-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      height: "20px",
      width: "40px"
    }, [
      /*#__PURE__*/_createElementVNode("use", { href: _hoisted_3 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Worldline")
  ])
], -1))
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-1" }, "settings", -1))
const _hoisted_25 = {
  key: 1,
  class: "bg-warning missing-feature"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('paymentSettings'),
        mb: 4
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                class: "card-text",
                innerHTML: _ctx.$t('pharmaPaySettingsInfoMollie')
              }, null, 8, _hoisted_9),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'pharma-pay-mollie'},
                    class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", {
                class: "card-text",
                innerHTML: _ctx.$t('pharmaPaySettingsInfoPayconiq')
              }, null, 8, _hoisted_16),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'pharma-pay-payconiq'},
                    class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", {
                class: "card-text",
                innerHTML: _ctx.$t('pharmaPaySettingsInfoWorldline')
              }, null, 8, _hoisted_23),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'pharma-pay-worldline'},
                    class: "btn btn-primary fw-700 d-inline-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('configure')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}